export default {"src":"/_next/static/media/cart_icon.a70c66b1.svg","height":23,"width":19,"blurWidth":0,"blurHeight":0};